import set from 'lodash.set';
import types from './constants';

const defaultReducer = (state) => (state);

let lastEmittedIsListening = false;

const isListeningChange = (state, action) => {

  const newIsListening = action.isListening;
  // dispatch custom event micIconStateChange to the window object when the isListening state changes
  // this is used to track the state of the mic icon for logging purposes.
  if (typeof window !== 'undefined' && lastEmittedIsListening !== newIsListening) {
    lastEmittedIsListening = newIsListening;
    
    const micStateEvent = new CustomEvent('micIconStateChange', { 
      detail: { 
        isListening: newIsListening,
      } 
    });
    
    window.dispatchEvent(micStateEvent);
  }
  let next = JSON.parse(JSON.stringify(state));
  set(next, 'listener.isListening', action.isListening);
  return next;
}

const actionReducer = {
  [types.IS_LISTENING_CHANGE]: isListeningChange,
};

export default (state = {}, action = {type: null}) => {
  const reducer = actionReducer[action.type] || defaultReducer;
  return reducer(state, action);
}
